const scrollArrow = document.querySelectorAll('.scroll-arrow');

const getNextSiblingBySelector = function (elem, selector) {
  let sibling = elem.nextElementSibling;

  if (!selector) return sibling;

  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.nextElementSibling;
  }
};

function scrollToBody(e) {
  const thisModule = e.target.closest('.module--block') || e.target.closest('.module');
  const firstModule = getNextSiblingBySelector(thisModule, '.module');
  const firstModuleBlock = getNextSiblingBySelector(thisModule, '.module--block');
  const scrollModule = firstModule || firstModuleBlock;

  scrollModule.scrollIntoView({
    behavior: 'smooth' 
  });
}

if (scrollArrow.length > 0) {
  for (let i = 0; i < scrollArrow.length; i++) {
    scrollArrow[i].addEventListener('click', scrollToBody);
  }
}
